// removed by extract-text-webpack-plugin
module.exports = {"aiButtonContainer":"src-components-Messages-MessagesEditor-__MessageEditor__aiButtonContainer--R5yI5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/MessagesEditor/MessageEditor.css
// module id = 1972
// module chunks = 0